import { render, staticRenderFns } from "./manybo-loadMore.vue?vue&type=template&id=399137fc&scoped=true"
import script from "./manybo-loadMore.vue?vue&type=script&lang=js"
export * from "./manybo-loadMore.vue?vue&type=script&lang=js"
import style0 from "./manybo-loadMore.vue?vue&type=style&index=0&id=399137fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399137fc",
  null
  
)

export default component.exports